import { defaultFeedbackMessage } from '../../constants/feedback-content';
import { GameDocument } from '../../types/game-document';
import { GetResourceValue } from './resources';

export const GetDefaultMessage = (
  type:
    | 'defaultAllCorrectFeedbackMessageResId'
    | 'defaultAllWrongFeedbackMessageResId',
  gameDocument: GameDocument
) => {
  if (gameDocument?.settings && gameDocument?.settings.designer) {
    const message = GetResourceValue(
      gameDocument,
      gameDocument.settings.designer[type] ?? ''
    );

    const value =
      message === '' ||
      (type === 'defaultAllCorrectFeedbackMessageResId' &&
        message === 'All correct feedback message default') ||
      (type === 'defaultAllWrongFeedbackMessageResId' &&
        message === 'All wrong feedback message default')
        ? defaultFeedbackMessage[type]
        : message;
    return value;
  }

  return defaultFeedbackMessage[type];
};
